// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1lIPo","option":"styles_option__2YgC0","selected":"styles_selected__1fVJ7"};